const normalizeToArray = value => {
  if (Array.isArray(value)) {
    return value
  }

  if (value === undefined || value === null) {
    return []
  }

  return [value]
}

export const hasEmployeePaymentType = paymentTypes => {
  return normalizeToArray(paymentTypes).some(paymentType => String(paymentType).toLowerCase() === 'employee')
}

export const stripNullLegalEntities = legalEntities => {
  return normalizeToArray(legalEntities).filter(
    legalEntityId => legalEntityId !== null && legalEntityId !== 'null' && legalEntityId !== ''
  )
}

export const prepareLegalEntitiesForPayload = (paymentTypes, legalEntities) => {
  const legalEntitiesForPayload = stripNullLegalEntities(legalEntities)

  if (!hasEmployeePaymentType(paymentTypes)) {
    return legalEntitiesForPayload.length ? legalEntitiesForPayload : undefined
  }

  return [...legalEntitiesForPayload, null]
}

export const prepareFilterWithEmployeeLegalEntities = ({ filter, paymentTypeKey, legalEntityKey, paymentTypes }) => {
  if (!filter || typeof filter !== 'object') {
    return filter
  }

  return {
    ...filter,
    [legalEntityKey]:
      prepareLegalEntitiesForPayload(paymentTypes ?? filter[paymentTypeKey], filter[legalEntityKey]) ??
      filter[legalEntityKey]
  }
}
